import React from 'react';
import { useTranslation } from 'react-i18next';
import { notification } from 'antd';
export default function ScheduleDownloadButton({ uid, alarm, fullName }) {
  const { t } = useTranslation();
  return <span></span>;
  return (
    <img
      alt={t('ICS kalendár pre rozvrh')}
      src={'/images/ics.png'}
      title={t(
        'Skopírovať odkaz na kalendár rozvrhu vo formáte ICS do schránky',
      )}
      style={{ height: '16px', marginBottom: '3px' }}
      onClick={() => {
        // Define the full URL to copy
        const url = `${window.location.protocol}//${window.location.hostname}/kalendar/${fullName.normalize('NFKD').replace(/\p{Diacritic}/gu, '')}?uid=${uid}&alarm=${alarm}`;
        // Copy to clipboard
        navigator.clipboard
          .writeText(url)
          .then(() => {
            // Show a success notification
            notification.success({
              message: t(
                'Odkaz na rozvrh vo formáte ICS bol skopírovaný do schránky.',
              ),
            });
          })
          .catch((error) => {
            // Show an error notification if it fails
            notification.error({
              message: t('Kopírovanie zlyhalo.'),
            });
          });
      }}
    />
  );
}
